/**
 * <s-inquiry-summary>
 * Live summary of the surrounding inquiry form. Lists every filled
 * contact[...] field (skipping zero counts and the free message) so the
 * customer can check their inquiry before sending it.
 */
const SKIP = new Set(['body', 'Lieferadresse']);

class InquirySummary extends HTMLElement {
  connectedCallback() {
    this.form = this.closest('form');
    this.list = this.querySelector('[data-summary-list]');
    this.empty = this.querySelector('[data-summary-empty]');
    if (!this.form || !this.list) return;
    this.update = this.update.bind(this);
    this.form.addEventListener('input', this.update);
    this.form.addEventListener('change', this.update);
    this.update();
  }

  disconnectedCallback() {
    this.form?.removeEventListener('input', this.update);
    this.form?.removeEventListener('change', this.update);
  }

  update() {
    const data = new FormData(this.form);
    const rows = [];
    for (const [rawName, rawValue] of data.entries()) {
      const match = /^contact\[(.+)\]$/.exec(rawName);
      if (!match) continue;
      const key = match[1];
      const value = String(rawValue).trim();
      if (SKIP.has(key) || value === '' || value === '0') continue;
      const field = this.form.elements.namedItem(rawName);
      const hiddenByLayout = field instanceof HTMLInputElement || field instanceof HTMLTextAreaElement ? field.type !== 'hidden' && !field.checkVisibility() : false;
      if (hiddenByLayout) continue;
      let label = key.charAt(0).toUpperCase() + key.slice(1);
      let shown = value;
      if (key === 'Übergabe' && value === 'Lieferung') {
        const address = String(data.get('contact[Lieferadresse]') || '').trim();
        if (address) shown = `${value}: ${address}`;
      }
      if (key === 'Mietbeginn' || key === 'Mietende') {
        const date = new Date(`${value}T00:00:00`);
        if (!Number.isNaN(date.getTime())) shown = date.toLocaleDateString(document.documentElement.lang || 'de');
      }
      rows.push([label, shown]);
    }

    this.list.replaceChildren(
      ...rows.flatMap(([label, value]) => {
        const dt = document.createElement('dt');
        dt.className = 'font-semibold';
        dt.textContent = label;
        const dd = document.createElement('dd');
        dd.className = 'text-on-surface/80 break-words';
        dd.textContent = value;
        return [dt, dd];
      })
    );
    if (this.empty) this.empty.hidden = rows.length > 0;
  }
}

if (!customElements.get('s-inquiry-summary')) {
  customElements.define('s-inquiry-summary', InquirySummary);
}
